import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Image} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'
import useSegment from '../../../../integrations/segment/app/hooks/use-segment'

export const MoreImageAndText = ({ITCLink, ITCText, alt, custom}) => {
    const segment = useSegment()
    const isGiftCardPurchase = ITCLink ? ITCLink.split('/').includes('giftcertpurchase') : false
    const linkTo = isGiftCardPurchase
        ? '/giftcertpurchase'
        : ITCLink.match(/\/products\/[^/]+/)[0].replace(/\.html$/, '')
    return (
        <Flex className={'moreImageAndText'} direction={'column'}>
            <Link
                to={linkTo}
                onClick={(event) => {
                    // segment
                    segment.sendPanelSelectedEvent(event, {})
                }}
            >
                <Image src={custom?.image?.disBaseLink} alt={alt} />
            </Link>
            <Flex
                direction={'column'}
                alignItems={'center'}
                justifyContent={'center'}
                textAlign={'center'}
                sx={{
                    h4: {
                        fontSize: 'xl'
                    },
                    p: {
                        fontSize: 'md'
                    }
                }}
                dangerouslySetInnerHTML={{
                    __html: ITCText
                }}
            />
        </Flex>
    )
}

MoreImageAndText.propTypes = {
    alt: PropTypes.string,
    custom: PropTypes.object,
    ITCLink: PropTypes.string,
    ITCText: PropTypes.string
}

export default MoreImageAndText
